import { Col, Row } from "antd";
import React from "react";
import { DataIndexItem } from "../../../../types/interfaces";

interface Props {
  data: DataIndexItem;
}

const SourceInfoDetails: React.FC<Props> = ({ data }) => {
  const lasMetaData = data.las_metadata
  return (
    <div className="source_info_box">
      <p className="source_info_title">Source Information</p>
      <Row gutter={[16, 16]}>
        <Col xs={12} sm={12} md={12} lg={10} xl={10} className="info_col_left">
          <div>EPSG</div>
        </Col>
        <Col xs={12} sm={12} md={12} lg={14} xl={14}>
          <div>- {lasMetaData?.epsg}</div>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col xs={12} sm={12} md={12} lg={10} xl={10} className="info_col_left">
          <div>Offsets</div>
        </Col>
        <Col xs={12} sm={12} md={12} lg={14} xl={14}>
          <div>- {lasMetaData?.offsets?.join(", ")}</div>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col xs={12} sm={12} md={12} lg={10} xl={10} className="info_col_left">
          <div>Mean</div>
        </Col>
        <Col xs={12} sm={12} md={12} lg={14} xl={14}>
          <div>
            {(lasMetaData.mean_x || lasMetaData.mean_y || lasMetaData.mean_z) ? (
            <>
              - {lasMetaData.mean_x ? lasMetaData.mean_x.toFixed(2) : "N/A"}, {" "}
              {lasMetaData.mean_y ? lasMetaData.mean_y.toFixed(2) : "N/A"}, {" "}
              {lasMetaData.mean_z ? lasMetaData.mean_z.toFixed(2) : "N/A"}
            </>
            ) : (
              "-"
            )}
          </div>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col xs={12} sm={12} md={12} lg={10} xl={10} className="info_col_left">
          <div>Scale</div>
        </Col>
        <Col xs={12} sm={12} md={12} lg={14} xl={14}>
          <div>
            - {lasMetaData?.scales?.map((scales : number) => scales?.toFixed(2))?.join(", ")}{" "}
          </div>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col xs={12} sm={12} md={12} lg={10} xl={10} className="info_col_left">
          <div>Predicated Vertical</div>
        </Col>
        <Col xs={12} sm={12} md={12} lg={14} xl={14}>
          <div>- {lasMetaData?.predicted_veritcal || ""}</div>
        </Col>
      </Row>
    </div>
  );
};
export default SourceInfoDetails;
